import React, { Component } from 'react'
import ReactDOM from 'react-dom'
// window.$ = window.jQuery = require('jquery');

// import $ from 'jquery';
// import './style.scss'
// import classNames from 'classnames'

import {TimelineLite} from 'gsap'


export default class Loader extends Component {
	constructor(props) {
    super(props)

    this.loader = require('../../Assets/Images/preloader.png')

    this.state = {
   		loading: true
    }
  }
  
  componentWillAppear(callback){
    // console.log('loader component will appear')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 1
    }).to(el, .5, {
      opacity: 1
    }) 
  }

  componentDidAppear() {
    // console.log('loader component did appear')
  }

  componentWillEnter (callback) {
    // console.log('loader component will enter')
    const el = ReactDOM.findDOMNode(this)
    var tween = new TimelineLite({ onComplete: callback })

    tween.set(el, {
      opacity: 0
    }).to(el, 0.8, {
      opacity: 1
    })
  }

  componentDidEnter () {
    // console.log('loader component entered')
  }

  componentWillLeave (callback) {
    // console.log('loader component will leave')
    const el = ReactDOM.findDOMNode(this)
    const text = el.querySelector('h1')
    var tween = new TimelineLite({ onComplete: callback })


    tween.to(el, 0.8, {
      opacity: 0
    }, 3.2)
  }

  componentDidLeave () {
    // console.log('loader component left')
    this.props.loaderRemoved()
  }

  setToComplete() {
    this.setState({loading: false})
  }


  render() {
    let text = this.state.loading ? this.props.loadingText : this.props.completeText
    return (
      <div className='loader'>
        <div className="content">
          <div className="img-container">
            <div className="cog cog1"></div>
            <div className="cog cog2"></div>
            <img src={this.loader} alt=""/>
          </div>
        	<h1 className="futural-light gradient-text">{text}</h1>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/react.loader/index.js